export enum InsuranceStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Declined = 'Declined',
    OnHold = 'OnHold',
    Canceled = 'Canceled',
}
